import axios from '@/jslib/axios'

export const getOrderList = params => {
  return axios({
    method: 'get',
    url: '/admin/order/list',
    params
  })
}

export const getOrderDetail = params => {
  return axios({
    method: 'get',
    url: '/admin/order/detail',
    params
  })
}
export const saveOrder = data => {
  return axios({
    method: 'post',
    url: '/admin/order/save',
    data
  })
}
export const voidOrder = data => {
  return axios({
    method: 'post',
    url: '/admin/order/void',
    data
  })
}
export const rebuildOrderPDF = data => {
  return axios({
    method: 'post',
    url: '/admin/order/rebuild/pdf',
    data
  })
}
export const updateOrderVRD = data => {
  return axios({
    method: 'post',
    url: '/admin/order/update/vrd',
    data
  })
}
export const resendOrderSMS = data => {
  return axios({
    method: 'post',
    url: '/admin/order/resend/sms',
    data
  })
}
